export default {
  roles: {
    admin: "ADMIN",
    member: "MEMBER",
    owner: "OWNER",
    standard: "USER",
  },
};
